<template>
	<div>
		<v-form v-model="isFormValid" lazy-validation ref="formDocumentosAdesao">
			<az-container>
				<v-row>
					<v-col cols="3">
						<label-personalizado
							style="padding-bottom: 8px"
							nome-campo="N° Processo"
							:obrigatorio-por-padrao="numeroProcessoObrigatorio"
							:apresentaTooltip="ehMascaraNumeroProcessoAtivo"
							:mensagemPadraoTooltip="tooltipMascaraNumeroProcesso"
							:style="{ paddingBottom: ehMascaraNumeroProcessoAtivo ? '8px' : '12px' }"
						></label-personalizado>
						<campo-mascara-regex
							id="numeroProcesso"
							v-model="adesao.numeroProcesso"
							name="N° Processo"
							clearable
							:validate="{
								required: numeroProcessoObrigatorio,
								regex: validacaoMascaraNumeroProcesso,
							}"
							maxlength="50"
							:rules="numeroProcessoRule"
							placeholder="Informe o número do processo"
							:regex="mascaraNumeroProcesso"
							:disabled="
								!temPermissao ||
								isAtaCancelada ||
								isConcluida ||
								estaRecusada ||
								!verificarPermissao(permissoes.ataAdesaoNumeroProcessoEditar) ||
								!isPermissaoAutorizada(permissoes.ataAdesaoNumeroProcessoEditar) ||
								(gerarNumeroProcessoAutomaticoAdesao && !isAdesaoExterna)
							"
						></campo-mascara-regex>
					</v-col>
					<v-col cols="9">
						<label-personalizado
							nome-campo="Justificativa"
							:obrigatorio-por-padrao="justificativaObrigatoria"
						></label-personalizado>
						<v-textarea
							placeholder="Informe a Justificativa"
							rows="1"
							v-model="adesao.justificativa"
							:disabled="
								!temPermissao ||
								isAtaCancelada ||
								isConcluida ||
								estaRecusada ||
								!verificarPermissao(permissoes.ataAdesaoJustificativaEditar) ||
								!isPermissaoAutorizada(permissoes.ataAdesaoJustificativaEditar)
							"
							:rules="justificativaAdesaoRule"
							counter
						></v-textarea>
					</v-col>
				</v-row>
				<v-row v-if="!isAdesaoExterna">
					<v-col cols="3">
						<label-personalizado
							nome-campo="DOE"
							:obrigatorio-por-padrao="doeAdesaoObrigatorio"
						></label-personalizado>
						<v-text-field
							id="adesao-doe"
							v-model="adesao.doe"
							maxlength="250"
							:disabled="
								!temPermissao ||
								isAtaCancelada ||
								!podeExibirBotaoSalvar ||
								estaRecusada ||
								!verificarPermissao(permissoes.ataAdesaoDoeEditar) ||
								!isPermissaoAutorizada(permissoes.ataAdesaoDoeEditar)
							"
							:rules="doeAdesaoRule"
						></v-text-field>
					</v-col>
				</v-row>
			</az-container>
			<v-divider></v-divider>
			<controle-documentos-generico-view
				:key="atualizaListagem"
				ref="docsAdesaoRef"
				:tipo-documento="tipoModeloDocumento.ADESAO"
				:menu-acoes-itens="acoesItensMenu"
				:coluna-juntado-habilitada="isProcessoDigitalAtivo || processoVirtualizacaoDiferenteDaAta"
				:coluna-convidados-habilitada="isProcessoDigitalAtivo || processoVirtualizacaoDiferenteDaAta"
				:permissao-redigir="permissoes.ataAdesaoDocumentoRedigir"
				:usuario-possui-permissao-para-juntar="usuarioPermissaoParaJuntar"
				:permissao-concluir-edicao-documento="permissoes.ataAdesaoDocumentoConcluirEdicao"
				:id-pasta-externa-digital="adesao.idPastaExternaDigital"
				:repositorio-flowbee="adesao.repositorioFlowbee"
				:permissao-assinar-eletronicamente="permissoes.ataAdesaoDocumentoAssinaturaEletronicaCriar"
				:permissao-assinar-digitalmente="permissoes.ataAdesaoDocumentoAssinaturaDigitalCriar"
				:permissao-juntar="permissoes.ataAdesaoJuntarDocumento"
				:permissao-excluir-documento="permissoes.ataAdesaoDocumentoExcluir"
				:permissao-baixar-documento="permissoes.ataAdesaoDocumentoBaixar"
				:permissao-cancelar-documento="permissoes.ataAdesaoDocumentoCancelar"
				:permissao-convidar-signatarios="permissoes.ataAdesaoDocumentoConvidarSignatarios"
				:permissao-desentranhar-documento="permissoes.ataAdesaoDocumentoDesentranharCriar"
				:permissao-pncp-enviar="permissoes.ataAdesaoDocumentoPncpEnviar"
				:permissao-pncp-excluir="permissoes.ataAdesaoDocumentoPncpExcluir"
				:exibir-acoes-pncp="podeExibirAcoesPncp"
				:has-authority="temPermissao && !isAtaCancelada && !isAtaProrrogada"
				:exibir-acoes-processo-digital="exibirAcoesProcessoDigital"
			></controle-documentos-generico-view>
			<v-divider></v-divider>
			<div class="mt-5">
				<botao-cancelar-confirmar
					:is-confirmar-desabilitado="
						!temPermissao ||
						!isFormValid ||
						isAtaCancelada ||
						isAtaProrrogada ||
						estaRecusada ||
						!verificarPermissao(permissoes.ataAdesaoEditar) ||
						!isPermissaoAutorizada(permissoes.ataAdesaoEditar)
					"
					nome-botao-confirmar="Salvar"
					:is-confirmar-visivel="podeExibirBotaoSalvar"
					:acao-confirmar="salvar"
					:acao-cancelar="carregar"
					:permissao-confirmar="permissoes.ataAdesaoEditar"
				></botao-cancelar-confirmar>
			</div>
		</v-form>
	</div>
</template>
<script>
import ControleDocumentosGenericoView from '@/views/components/documentos/controle-documentos/ControleDocumentosGenericoView.vue'
import { actionTypes, permissoes, tipoModeloDocumento } from '@/core/constants'
import BotaoCancelarConfirmar from '@/views/components/BotaoCancelarConfirmar.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import CampoMascaraRegex from '@/views/components/CampoMascaraRegex.vue'
import { mapState } from 'vuex'
import adesaoAta from '@/views/mixins/adesaoAta'
import validacaoAta from '@/views/mixins/validacaoAta'

export default {
	name: 'adesao-documentos-view',
	components: { CampoMascaraRegex, LabelPersonalizado, BotaoCancelarConfirmar, ControleDocumentosGenericoView },
	mixins: [adesaoAta, validacaoAta],
	data() {
		return {
			idAdesao: this.$route.params.id,
			isFormValid: false,
			permissoes,
			exibirAcoesProcessoDigital: false,
			processoVirtualizacaoDiferenteDaAta: false,
			numeroProcessoObrigatorio: true,
			acoesItensMenu: {
				nome: 'Adicionar',
				itens: [
					{
						titulo: 'Documento',
						icone: {
							nome: 'description',
						},
						evento: 'adicionar-documento',
						authorization: permissoes.ataAdesaoDocumentoAdicionar,
					},
					{
						titulo: 'Anexo',
						icone: {
							nome: 'attach_file',
						},
						evento: 'adicionar-anexo',
						authorization: permissoes.ataAdesaoAnexoAdicionar,
					},
				],
			},
		}
	},
	computed: {
		...mapState({
			adesao: (state) => state.adesao.informacoesAdesao || {},
			parametrosSistema: (state) => state.parametrosSistema,
			justificativaObrigatoria: (state) => state.parametrosSistema.usaJustificativaObrigatoriaAdesao || false,
			isProcessoDigitalAtivo: (state) => state.parametrosSistema.isProcessoDigitalAtivo || false,
			doeAdesaoObrigatorio: (state) => state.parametrosSistema.doeAdesaoObrigatorio || false,
			atualizaListagem: (state) => state.adesao.atualizaListagem,
			isIntegracaoWeblicAtivo: (state) => state.parametrosSistema.isIntegracaoWeblicAtivo,
		}),
		justificativaAdesaoRule() {
			return [
				(value) => {
					if (!this.justificativaObrigatoria) return true
					return (!!value && !!value.trim()) || 'Justificativa é obrigatória'
				},
			]
		},
		numeroProcessoRule() {
			return [
				(value) => {
					if (!this.numeroProcessoObrigatorio) return true
					return (!!value && !!value.trim()) || 'Número processo é obrigatório'
				},
			]
		},
		doeAdesaoRule() {
			return [
				(v) => !v || v?.length <= 250 || 'O campo doe deve ser igual ou menor do que 250 caracteres.',
			]
		},
		ehMascaraNumeroProcessoAtivo() {
			return (
				this.parametrosSistema.regexMascaraNumeroProcessoAtivoAdesao &&
				(this.isAdesaoExterna || !this.gerarNumeroProcessoAutomaticoAdesao)
			)
		},
		mascaraNumeroProcesso() {
			return this.ehMascaraNumeroProcessoAtivo ? this.parametrosSistema.regexMascaraNumeroProcessoAdesao : ''
		},
		tooltipMascaraNumeroProcesso() {
			return this.parametrosSistema.regexMascaraNumeroProcessoTooltipAdesao
		},
		validacaoMascaraNumeroProcesso() {
			return this.ehMascaraNumeroProcessoAtivo ? this.mascaraNumeroProcesso : ''
		},
		gerarNumeroProcessoAutomaticoAdesao() {
			return this.parametrosSistema.gerarNumeroProcessoAutomaticoAdesao
		},
		isAtaProrrogada() {
			return this.ehHistoricoProrrogacao(this.adesao?.ataRegistroPreco.situacao)
		},
		isAtaCancelada() {
			return this.estaCancelada(this.adesao.ataRegistroPreco?.situacao)
		},
		tipoModeloDocumento() {
			return tipoModeloDocumento
		},
		usuarioPermissaoParaJuntar() {
			return true
		},
		isAtaPncp() {
			return !!this.adesao.ataRegistroPreco?.isEnviadaPncp
		},
		/**
		 * SRDP-5743 - Cliente SC permite atualização do campo DOE
		 * mesmo após adesão concluida.
		 */
		podeExibirBotaoSalvar() {
			return (
				!this.isConcluida || (this.isIntegracaoWeblicAtivo && !this.isFluxoFinalizado && !this.isAdesaoExterna)
			)
		},
		/**
		 * SRDP-5743 - Cliente SC permite enviar documentos para PNCP
		 * mesmo após adesão finalizada.
		 * temPermissao valida se fluxo está ativo, portanto não pode ser
		 * utilizado nas validações de fluxo finalizado.
		 */
		podeExibirAcoesPncp() {
			return (
				this.isAtaPncp &&
				((this.temPermissao && this.isConcluida) ||
					(this.isFluxoFinalizado && this.isIntegracaoWeblicAtivo && !this.isAdesaoExterna))
			)
		},
	},
	async mounted() {
		await this.carregar()
		await this.atualizaInstanciaDoProcesso()
	},
	methods: {
		async carregar() {
			await this.carregarAdesao(this.idAdesao)

			this.numeroProcessoObrigatorio = this.adesao.isNumeroProcessoObrigatorio
			this.exibirAcoesProcessoDigital = this.adesao.isExibirAcoesProcessoDigital
			this.processoVirtualizacaoDiferenteDaAta = this.adesao.isProcessoVirtualizacaoDiferenteDaAta
		},
		async salvar() {
			if (this.$refs.formDocumentosAdesao.validate()) {
				await this.$store.dispatch(actionTypes.ADESAO.EDITAR_ADESAO, this.adesao)
				this.mostrarNotificacaoSucesso('Adesão salva com sucesso!')
				await this.carregar()
			}
		},
	},
}
</script>
